export default __webpack_public_path__ + "static/media/cm_3.3c4596ba.png";